import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import RevenueReimbursementSearchResponse from "../RevenueReimbursementSearchResponse";
import ModelProxyClass from "./ModelProxyClass";
import Reimbursement from "../Reimbursement";


/**
 * @class RevenueReimbursementSearchResponseBase
 * @extends ModelBaseClass
 * @property {[Reimbursement]} reimbursements
 * @property {number} totalItemCount (int64)
 */
class RevenueReimbursementSearchResponseBase extends ModelBaseClass {
	/**
	 * @type {[Reimbursement]} reimbursements
	 */
	reimbursements;
	/**
	 * @type {number} totalItemCount (int64)
	 */
	totalItemCount;

	/**
	 * Instantiates a new instance of RevenueReimbursementSearchResponse based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {RevenueReimbursementSearchResponse}
	 */
	static create(genericObject) {
		const newRevenueReimbursementSearchResponse = new RevenueReimbursementSearchResponse();
		newRevenueReimbursementSearchResponse.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newRevenueReimbursementSearchResponse;
	}

	/**
	 * Instantiates a new array of RevenueReimbursementSearchResponse based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[RevenueReimbursementSearchResponse]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newRevenueReimbursementSearchResponseArray = [];
		genericArray.forEach(genericObject => {
			newRevenueReimbursementSearchResponseArray.push(RevenueReimbursementSearchResponse.create(genericObject));
		});
		return newRevenueReimbursementSearchResponseArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('reimbursements', '[Reimbursement]'),
	ModelBaseClass.createModelProperty('totalItemCount', 'integer'),
];

export default RevenueReimbursementSearchResponseBase;
